const userLayouts = {
  IS_AUTH: 'isAuth',
  IS_MAIN: 'isMain',
}

export default userLayouts
